module.exports = __webpack_public_path__ + "img/loading.a334fc9f.gif";